import styled from 'styled-components'

export const TableHeader = styled.th`
  text-align: left;
  width: 25%;
`
